const rawDomain = process.env.REACT_APP_POOL_AUTH_URL || "";
const domain = rawDomain.startsWith("http")
  ? rawDomain
  : `https://${rawDomain}`;

export const OAUTH_CALLBACK_PATH = "/auth-callback";

export const getCognitoConfig = () => ({
  domain,
  clientId: process.env.REACT_APP_POOL_CLIENT_ID,
  userPoolId: process.env.REACT_APP_POOL_ID,
  redirectUri:
    typeof window !== "undefined"
      ? `${window.location.origin}${OAUTH_CALLBACK_PATH}`
      : undefined,
  scope: "openid email",
});
